import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import './index.css';

function mountApplication() {
  const rootElement = document.getElementById('root');
  if (!rootElement) return;

  try {
    const root = createRoot(rootElement);
    root.render(
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    );

    // Dismiss preloader as soon as React starts mounting
    if (typeof (window as any).dismissAppPreloader === 'function') {
      (window as any).dismissAppPreloader();
    } else {
      const loader = document.getElementById('app-preloader');
      if (loader) loader.remove();
    }
  } catch (err: any) {
    console.error('Fatal render error:', err);
    try {
      fetch('/api/client-debug-log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source: 'main.tsx mount error',
          message: err?.message || String(err),
          stack: err?.stack,
        }),
      }).catch(() => {});
    } catch {}

    // Fallback UI directly into root to prevent blank white screen
    rootElement.innerHTML = `
      <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f8fafc; font-family: sans-serif; padding: 24px;">
        <div style="max-width: 420px; width: 100%; background: #ffffff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 28px; text-align: center; box-shadow: 0 10px 25px rgba(0,0,0,0.05);">
          <div style="width: 48px; height: 48px; border-radius: 12px; background: #fef3c7; color: #b45309; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; font-size: 24px; font-weight: bold;">!</div>
          <h2 style="font-size: 18px; font-weight: 800; color: #0f172a; margin: 0 0 8px;">Uygulama Yüklenirken Bir Aksaklık Oluştu</h2>
          <p style="font-size: 13px; color: #64748b; line-height: 1.5; margin: 0 0 20px;">Lütfen sayfayı yenileyiniz veya doğrudan ana sayfaya dönünüz.</p>
          <button onclick="window.location.reload()" style="background: #d97706; color: #ffffff; border: none; border-radius: 10px; padding: 10px 20px; font-weight: 700; font-size: 14px; cursor: pointer;">Sayfayı Yenile</button>
        </div>
      </div>
    `;

    if (typeof (window as any).dismissAppPreloader === 'function') {
      (window as any).dismissAppPreloader();
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApplication);
} else {
  mountApplication();
}

